module.exports = __webpack_public_path__ + "img/jiadu-propa.ed2578db.png";